(function () {
  class CclpQuizResults extends HTMLElement {
    constructor() {
      super();
      this._onScroll = this._onScroll.bind(this);
      this._onSectionLoad = this._onSectionLoad.bind(this);
      this._sliderHandlers = [];
      this._dotHandlers = [];
    }

    connectedCallback() {
      document.addEventListener('shopify:section:load', this._onSectionLoad);
      this._init();
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:section:load', this._onSectionLoad);
      this._destroy();
    }

    _onSectionLoad(event) {
      var target = event.target;
      if (target && typeof target.contains === 'function' && target.contains(this)) {
        this._init();
      }
    }

    _init() {
      this._destroy();
      this._track = this.querySelector('[data-track]');
      this._dots = this.querySelector('[data-dots]');
      this._initSliders();
      this._initDots();
    }

    _initSliders() {
      var self = this;
      var HIT_ZONE = 40;
      var cards = this.querySelectorAll('[data-ba]');

      cards.forEach(function (ba) {
        var slider = ba.querySelector('[data-ba-slider]');
        if (!slider) return;

        var update = function () {
          var v = Math.max(0, Math.min(100, Number(slider.value) || 0));
          ba.style.setProperty('--ba-pos', v + '%');
        };

        slider.addEventListener('input', update, { passive: true });
        slider.addEventListener('change', update, { passive: true });

        var dragging = false;

        var onTouchStart = function (e) {
          var rect = ba.getBoundingClientRect();
          var touchX = e.touches[0].clientX - rect.left;
          var currentPos =
            ((parseFloat(ba.style.getPropertyValue('--ba-pos')) || 50) / 100) * rect.width;
          if (Math.abs(touchX - currentPos) <= HIT_ZONE) {
            dragging = true;
            e.preventDefault();
          }
        };

        var onTouchMove = function (e) {
          if (!dragging) return;
          e.preventDefault();
          var rect = ba.getBoundingClientRect();
          var touchX = e.touches[0].clientX - rect.left;
          var pct = Math.max(0, Math.min(100, (touchX / rect.width) * 100));
          ba.style.setProperty('--ba-pos', pct + '%');
          slider.value = Math.round(pct);
        };

        var onTouchEnd = function () {
          dragging = false;
        };

        ba.addEventListener('touchstart', onTouchStart, { passive: false });
        ba.addEventListener('touchmove', onTouchMove, { passive: false });
        ba.addEventListener('touchend', onTouchEnd, { passive: true });

        self._sliderHandlers.push({
          ba: ba,
          slider: slider,
          update: update,
          onTouchStart: onTouchStart,
          onTouchMove: onTouchMove,
          onTouchEnd: onTouchEnd,
        });

        update();
      });
    }

    _initDots() {
      if (!this._track || !this._dots) return;

      var cards = this._track.children;
      if (!cards.length) return;

      for (var i = 0; i < cards.length; i++) {
        var button = document.createElement('button');
        button.type = 'button';
        button.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        if (i === 0) button.setAttribute('aria-current', 'true');

        var handler = (function (card) {
          return function () {
            card.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
          };
        })(cards[i]);

        button.addEventListener('click', handler);
        this._dotHandlers.push({ button: button, handler: handler });
        this._dots.appendChild(button);
      }

      this._track.addEventListener('scroll', this._onScroll, { passive: true });
    }

    _destroy() {
      if (this._track) {
        this._track.removeEventListener('scroll', this._onScroll);
      }

      if (this._sliderHandlers.length) {
        this._sliderHandlers.forEach(function (item) {
          item.slider.removeEventListener('input', item.update);
          item.slider.removeEventListener('change', item.update);
          item.ba.removeEventListener('touchstart', item.onTouchStart);
          item.ba.removeEventListener('touchmove', item.onTouchMove);
          item.ba.removeEventListener('touchend', item.onTouchEnd);
        });
        this._sliderHandlers = [];
      }

      if (this._dotHandlers.length) {
        this._dotHandlers.forEach(function (item) {
          item.button.removeEventListener('click', item.handler);
        });
        this._dotHandlers = [];
      }

      if (this._dots) {
        this._dots.replaceChildren();
      }

      this._track = null;
      this._dots = null;
    }

    _onScroll() {
      if (!this._track || !this._dots) return;

      var cards = this._track.children;
      if (!cards.length) return;

      var trackCenter = this._track.scrollLeft + this._track.offsetWidth / 2;
      var idx = 0;
      var minDist = Infinity;

      for (var i = 0; i < cards.length; i++) {
        var cardCenter = cards[i].offsetLeft + cards[i].offsetWidth / 2;
        var dist = Math.abs(trackCenter - cardCenter);
        if (dist < minDist) {
          minDist = dist;
          idx = i;
        }
      }

      Array.prototype.forEach.call(this._dots.children, function (dot, i) {
        if (i === idx) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }
  }

  if (!customElements.get('cclp-quiz-results')) {
    customElements.define('cclp-quiz-results', CclpQuizResults);
  }
})();
